// src/i18n/en/zones.js
export const zones = {
    name: 'Zone |||| Zones',
    title: 'Zone Management',
    titles: {
        list: 'Zones',
        create: 'New Zone',
        edit: 'Edit Zone',
        manage: 'Manage Zones',
    },
    fields: {
        id: 'ID',
        name: 'Name',
        hotel: 'Hotel',
        hotelId: 'Hotel',
        description: 'Description',
        lockerCount: 'Total lockers',
        availableCount: 'Available',
        occupiedCount: 'Occupied',
        maintenanceCount: 'Under maintenance',
        createdAt: 'Created',
        updatedAt: 'Updated',
    },
    actions: {
        create: 'New Zone',
        edit: 'Edit',
        delete: 'Delete',
        view_lockers: 'View lockers',
        add_lockers: 'Add lockers',
    },
    messages: {
        no_zones: 'No zones configured',
        loading: 'Loading zones...',
        create_success: 'Zone created successfully',
        update_success: 'Zone updated successfully',
        delete_success: 'Zone deleted successfully',
        delete_confirm: 'Are you sure you want to delete this zone?',
        has_lockers: 'This zone has assigned lockers',
    },
    validation: {
        name_required: 'Zone name is required',
        name_exists: 'A zone with that name already exists',
    },
    dialogs: {
        delete_title: 'Delete Zone',
        delete_message: 'Are you sure you want to delete the zone %{name}?',
        delete_warning: 'This action will affect all lockers in this zone.',
    },
    placeholders: {
        name: 'E.g.: Pool, Gym, Reception',
        description: 'Optional zone description',
    },
};
